import CopyLink from './copy-link';

export default CopyLink;
